import { Component, Input, OnInit } from '@angular/core';
import { MappingsWizardService } from '../wizard/mappings-wizard.service';

@Component({
  selector: 'app-movement-bar',
  templateUrl: './movement-bar.component.html',
  styleUrls: ['./movement-bar.component.scss']
})
export class MovementBarComponent implements OnInit {

  @Input() resolution: number;
  @Input() value: number | undefined;
  @Input() target: number | undefined;
  @Input() max: number | undefined;
  @Input() min: number | undefined;
  @Input() center: number | undefined;
  @Input() capturing: boolean | undefined;
  @Input() normalized: boolean | undefined;

  constructor(public mappingsWizard: MappingsWizardService) {
    //this.target = 0.6;
    //this.capturing = true;
  }

  ngOnInit() {
    if (this.target !== undefined) {
      console.log(this.target);
    } else {
      console.log('target undefined');
    }
  }

  valueInsideTarget() {
    if (this.target) {
      return this.mappingsWizard.discretize(this.value, this.resolution) === this.mappingsWizard.discretize(this.target, this.resolution);
    }
    return false;
  }

}
